let formId = '';

const originLocale = document.querySelector('.stockist-form').dataset.locale;
const originStokistStorage = localStorage['originStockist'];
if( originStokistStorage != undefined ) {
  let stockistLocale = originStokistStorage.split('|');
  stockistLocale.forEach((stockist) => {
    if(originLocale == stockist.split(":")[0]){
       formId = stockist.split(":")[1]
    }
   })
}
else {
   window.location.href = window.Shopify.routes.root + 'pages/carry-us';
}
const stockistForm = document.getElementById(formId);
stockistForm.classList.remove('inactive');
